import { createRevealExportService } from "app/pages/sales-intelligence/common-components/table-actions-panel/services/revealExportService";

export const exportContactRevealService = createRevealExportService();
